
import { GroupLeaderRequest } from "@/types/admin-requests";
import { Card } from "@/components/ui/card";
import { RequestCard } from "./RequestCard";

interface RequestListProps {
  requests: GroupLeaderRequest[];
  processingId: string | null;
  onApprove: (request: GroupLeaderRequest) => Promise<void>;
  onReject: (request: GroupLeaderRequest) => Promise<void>;
  onDelete: (request: GroupLeaderRequest) => Promise<void>;
  onSendInvitation: (request: GroupLeaderRequest) => Promise<void>;
  onResetPassword?: (request: GroupLeaderRequest) => Promise<void>;
}

export const RequestList = ({
  requests,
  processingId,
  onApprove,
  onReject,
  onDelete,
  onSendInvitation,
  onResetPassword,
}: RequestListProps) => {
  if (requests.length === 0) {
    return (
      <Card>
        <div className="p-6 text-center text-muted-foreground">
          Inga väntande förfrågningar
        </div>
      </Card>
    );
  }

  return (
    <div className="grid gap-4">
      {requests.map((request) => (
        <RequestCard
          key={request.id}
          request={request}
          processingId={processingId}
          onApprove={onApprove}
          onReject={onReject}
          onDelete={onDelete}
          onSendInvitation={onSendInvitation}
          onResetPassword={onResetPassword}
        />
      ))}
    </div>
  );
};
